"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = void 0;
var styles = {
  root: {
    position: 'relative'
  },
  canvasControls: {
    cursor: 'move',
    position: 'absolute',
    zIndex: 100,
    width: '100%'
  },
  canvasPreview: {
    width: '100%'
  }
};
exports.styles = styles;